/**
 * cookie情報を取得
 */
export function getCookie(key: string): string {
  const name = key + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * cookie情報を設定
 */
export function setCookie(key: string): void {
  document.cookie = key;
}
